const genmap = require('./generate_asset_map');
const isServer = typeof genmap === 'function';
let prefix = '';
let manifest = {};
try {
  //eslint-disable-next-line node/no-missing-require
  manifest = require('../dist/manifest.json');
} catch (e) {
  // use middleware
}

const assets = isServer ? manifest : genmap;

function getAsset(name) {
  const resolved = assets[name];
  if (resolved == null && typeof console !== 'undefined' && console.warn) {
    // Avoid emitting src="undefined" → GET /undefined
    console.warn('[assets] missing key:', name);
    return '';
  }
  return prefix + resolved;
}

function setPrefix(name) {
  prefix = name;
}

function getMatches(match) {
  return Object.keys(assets)
    .filter(k => match.test(k))
    .map(getAsset);
}

const instance = {
  setPrefix: setPrefix,
  get: getAsset,
  match: getMatches,
  setMiddleware: function(middleware) {
    function getManifest() {
      return JSON.parse(
        middleware.fileSystem.readFileSync(
          middleware.getFilenameFromUrl('/manifest.json')
        )
      );
    }
    if (middleware) {
      instance.get = function getAssetWithMiddleware(name) {
        const m = getManifest();
        const resolved = m[name];
        if (resolved == null && typeof console !== 'undefined' && console.warn) {
          console.warn('[assets] missing manifest key:', name);
          return '';
        }
        return prefix + resolved;
      };
      instance.match = function matchAssetWithMiddleware(match) {
        const m = getManifest();
        return Object.keys(m)
          .filter(k => match.test(k))
          .map(k => prefix + m[k]);
      };
    }
  }
};

module.exports = instance;
